import { render, staticRenderFns } from "./HedgingCostsEstimatedBankFeesTableBlock.vue?vue&type=template&id=4c1349fe&scoped=true"
import script from "./HedgingCostsEstimatedBankFeesTableBlock.vue?vue&type=script&lang=js"
export * from "./HedgingCostsEstimatedBankFeesTableBlock.vue?vue&type=script&lang=js"
import style0 from "./HedgingCostsEstimatedBankFeesTableBlock.vue?vue&type=style&index=0&id=4c1349fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1349fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
